import type { CustomCellEditorProps } from "ag-grid-react";

import { HtmlFieldEditor } from "@/components/HtmlFieldEditor";

export function HtmlTableCellEditor({
  value,
  onValueChange,
}: CustomCellEditorProps<unknown, string>) {
  const stringValue = value != null ? String(value) : "";

  return (
    <div className="html-table-cell-editor w-[min(520px,calc(100vw-2rem))] p-1">
      <HtmlFieldEditor
        value={stringValue}
        onChange={(next) => onValueChange(next)}
      />
    </div>
  );
}
